import { createAction, props } from "@ngrx/store";
import { BusinessDetails } from "../../models/business-details.models";
import { City } from "../../models/city.models";
import { ContactDetails } from "../../models/contact-details.model";
import { InsureItems } from "../../models/insure-items.model";
import { InvestmentDetails } from "../../models/InvestmentDetails.model";
import { PersonalDetails } from "../../models/personal-details.model";
import { QuoteDetails } from "../../models/quote-details.models";



export const SET_LOADING_ACTION = '[shared state] set loading spinner';
export const GET_ENQUIRY_ID = '[shared state] get enquiry id';
export const GET_ENQUIRY_ID_SUCCESS = '[shared state] get enquiry id success';
export const SET_ENQUIRY_ID = '[shared state] set enquiry id';

export const SAVE_CONTACT_DETAILS_ACTION = '[pre quote page] save contact details';
export const SAVE_PERSONAL_DETAILS_ACTION = '[pre quote page] save personal details';
export const SAVE_INVESTMENT_DETAILS_ACTION = '[pre quote page] save investment details';

export const GET_QUOTE_DETAILS = '[pre quote page] get quote details';
export const GET_QUOTE_DETAILS_SUCCESS = '[pre quote page] get quote details success';

export const SAVE_QUOTE_DETAILS = '[pre quote page] save quote details';
export const SAVE_QUOTE_DETAILS_SUCCESS = '[pre quote page] save quote details success';

export const UPDATE_QUOTE_DETAILS = '[pre quote page] update quote details';
export const UPDATE_QUOTE_DETAILS_SUCCESS = '[pre quote page] update quote details success';

export const SELECT_PREMIUM = '[quote page] Select Premium';
export const SELECT_PREMIUM_SUCCESS = '[quote page] Select Premium success';


// export const 

export const setLoadingSpinner = createAction(SET_LOADING_ACTION, props<{ status: boolean}>());
export const getNewEnquiryId = createAction(GET_ENQUIRY_ID);
export const getNewEnquiryIdSuccess = createAction(GET_ENQUIRY_ID_SUCCESS, props<{ enquiry_id: string }>());
export const setEnquiryId = createAction(SET_ENQUIRY_ID, props<{ enquiry_id: string }>());

export const saveContactDetails = createAction(SAVE_CONTACT_DETAILS_ACTION, props<{ contactDetails: ContactDetails }>());
export const savePersonalDetails = createAction(SAVE_PERSONAL_DETAILS_ACTION, props<{ personalDetails: PersonalDetails }>());
export const saveInvestmentDetails = createAction(SAVE_INVESTMENT_DETAILS_ACTION, props<{ investmentDetails: InvestmentDetails }>());

export const getQuoteDetails = createAction(GET_QUOTE_DETAILS, props<{ enquiry_id: string }>());
export const getQuoteDetailsSuccess = createAction(GET_QUOTE_DETAILS_SUCCESS, props<{ quote_details: QuoteDetails }>());

export const saveQuoteDetails = createAction(SAVE_QUOTE_DETAILS, props<{ quote_details: QuoteDetails }>());
export const saveQuoteDetailsSuccess = createAction(SAVE_QUOTE_DETAILS_SUCCESS, props<{ enquiry_id: string }>());

export const updateQuoteDetails = createAction(UPDATE_QUOTE_DETAILS, props<{ enquiry_id: string, quote_details: QuoteDetails }>());
export const updateQuoteDetailsSuccess = createAction(UPDATE_QUOTE_DETAILS_SUCCESS, props<{ enquiry_id: string }>());

export const selectPremium = createAction(SELECT_PREMIUM, props<{ enquiry_id: string, insurer_id: number, plan_key: string, basic_info: any }>())
export const selectPremiumSuccess = createAction(SELECT_PREMIUM_SUCCESS)